import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import contractMappingComponent from './contract-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let contractMappingModule = angular.module('contractMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-contract-mapping', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/contract-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Contract Mapping Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<contract-mapping></contract-mapping>'
  })

})

.component('contractMapping', contractMappingComponent);

export default contractMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/contract-mapping/contract-mapping.js